// 销售合同下「业务单据」页面统一出口
// 每个单据页面独立一个 JS 文件（本目录），这里只做聚合，主页面按需 import
import RoomOrders from "./RoomOrders.js";
import AddedServices from "./AddedServices.js";
import Payments from "./Payments.js";
import Collections from "./Collections.js";
import Balances from "./Balances.js";
import FinanceContracts from "./FinanceContracts.js";
import Invoices from "./Invoices.js";
import Refunds from "./Refunds.js";
import Approvals from "./Approvals.js";

// 业务单据宫格顺序（与预览图 3×3 一致）
export const billConfigs = [
  RoomOrders,
  AddedServices,
  Payments,
  Collections,
  Balances,
  FinanceContracts,
  Invoices,
  Refunds,
  Approvals
];

// 业务流程阶段（与后端 CRMOrdersController 口径一致）
// 后端另见：stage==5 时映射为 执行中 / 取消退款
export const CONTRACT_STAGE_MAP = {
  1: "待执行",
  2: "已预定",
  3: "已支付",
  4: "已全款"
};

export const CONTRACT_STAGES = [
  { value: 1, label: "待执行" },
  { value: 2, label: "已预定" },
  { value: 3, label: "已支付" },
  { value: 4, label: "已全款" }
];

// 当前阶段序号（1~4）；非 1~4（如 5 取消退款 / 未知）返回 0
export function stageIndex(stage) {
  const n = Number(stage);
  return n >= 1 && n <= 4 ? n : 0;
}

// 阶段名称（优先用本映射，保证与进度条口径一致；5 由后端返回文案兜底）
export function stageLabel(stage, backendName) {
  const n = Number(stage);
  if (CONTRACT_STAGE_MAP[n]) return CONTRACT_STAGE_MAP[n];
  return backendName || "未知阶段";
}

// 进度百分比：当前阶段 / 总阶段
export function stagePercent(stage) {
  const i = stageIndex(stage);
  if (!i) return 0;
  return Math.round((i / CONTRACT_STAGES.length) * 100);
}

export default billConfigs;



// WEBPACK FOOTER //
// ./src/pages/contract/index.js